document.addEventListener("DOMContentLoaded", function () {
 // Header: mobile nav toggle + shrink logo on scroll
 const header = document.getElementById('header');
 const toggle = header.querySelector('.menu-toggle');

 toggle.addEventListener('click', function() {
     const open = header.classList.toggle('nav-open');
     toggle.setAttribute('aria-expanded', open);
 });

 header.querySelectorAll('.nav a').forEach(function(link) {
     link.addEventListener('click', function() {
         header.classList.remove('nav-open');
         toggle.setAttribute('aria-expanded', false);
     });
 });

 const onScroll = function() {
     header.classList.toggle('scrolled', window.scrollY > 50);
 };
 onScroll();
 window.addEventListener('scroll', onScroll, { passive: true });

 // Gallery: duplicate the slides so the CSS scroll animation loops seamlessly
 document.querySelectorAll('.gallery-track').forEach(function(track) {
     Array.from(track.children).forEach(function(item) {
         const clone = item.cloneNode(true);
         clone.setAttribute('aria-hidden', 'true');
         track.appendChild(clone);
     });
 });

 // Featured menu + events: click-and-drag scrolling for mouse users
 document.querySelectorAll('.menu-carousel, .events-carousel').forEach(function(carousel) {
     let startX = 0;
     let startScroll = 0;
     let isDown = false;

     carousel.addEventListener('pointerdown', function(e) {
         if (e.pointerType !== 'mouse') return;
         isDown = true;
         startX = e.clientX;
         startScroll = carousel.scrollLeft;
     });

     carousel.addEventListener('pointermove', function(e) {
         if (!isDown) return;
         const delta = e.clientX - startX;
         if (Math.abs(delta) > 5) carousel.classList.add('dragging');
         carousel.scrollLeft = startScroll - delta;
     });

     const end = function() {
         isDown = false;
         carousel.classList.remove('dragging');
     };
     carousel.addEventListener('pointerup', end);
     carousel.addEventListener('pointerleave', end);
 });

 // Prev/next arrows: only shown when the carousel has more than fits on screen
 document.querySelectorAll('.carousel-nav').forEach(function(nav) {
     const carousel = document.querySelector(nav.dataset.carousel);
     const prev = nav.querySelector('.carousel-prev');
     const next = nav.querySelector('.carousel-next');

     const step = function() {
         const items = carousel.firstElementChild.children;
         return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : carousel.clientWidth;
     };

     const update = function() {
         const max = carousel.scrollWidth - carousel.clientWidth;
         nav.hidden = max <= 1;
         prev.disabled = carousel.scrollLeft <= 1;
         next.disabled = carousel.scrollLeft >= max - 1;
     };

     prev.addEventListener('click', function() {
         carousel.scrollBy({ left: -step(), behavior: 'smooth' });
     });
     next.addEventListener('click', function() {
         carousel.scrollBy({ left: step(), behavior: 'smooth' });
     });

     carousel.addEventListener('scroll', update, { passive: true });
     window.addEventListener('resize', update);
     update();
 });

 // Menu page: tab buttons switch which set of menu images is shown
 document.querySelectorAll('.menu-tabs').forEach(function(tablist) {
     const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));

     const select = function(tab) {
         tabs.forEach(function(t) {
             const selected = t === tab;
             t.setAttribute('aria-selected', selected);
             t.tabIndex = selected ? 0 : -1;
             document.getElementById(t.getAttribute('aria-controls')).hidden = !selected;
         });
     };

     tabs.forEach(function(tab, i) {
         tab.addEventListener('click', function() {
             select(tab);
             history.replaceState(null, '', '#' + tab.dataset.menu);
         });

         // Arrow keys move between tabs
         tab.addEventListener('keydown', function(e) {
             const dir = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
             if (!dir) return;
             e.preventDefault();
             const next = tabs[(i + dir + tabs.length) % tabs.length];
             next.click();
             next.focus();
         });
     });

     // Open the menu named in the URL, e.g. /menu/#bar
     const fromHash = function() {
         const tab = tabs.find(function(t) {
             return '#' + t.dataset.menu === window.location.hash;
         });
         if (tab) select(tab);
     };
     fromHash();
     window.addEventListener('hashchange', fromHash);
 });

 document.querySelectorAll('.newsletter').forEach(function(form) {
     form.addEventListener('submit', function(e) {
         e.preventDefault();
         const data = new FormData(form);

         fetch(form.action, {
             method: 'POST',
             body: new URLSearchParams(data),
             credentials: 'omit',
         })
         .then(function() {
             form.querySelector('.inputs-wrap').innerHTML = '<p class="newsletter-thanks">Thanks for signing up!</p>';
         })
         .catch(function(err) {
             console.log(err);
         });
     });
 });
});
